import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslocoModule, TranslocoService } from '@jsverse/transloco';
import { IgntrIconComponent } from 'app/shared/igntr';
import {
  BreadcrumbComponent,
  BreadcrumbItem,
} from 'app/modules/shared/components/breadcrumb/breadcrumb.component';

@Component({
  selector: 'app-dashboard-header',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    TranslocoModule,
    IgntrIconComponent,
    BreadcrumbComponent,
  ],
  template: `
    <header
      class="hidden md:flex sticky top-0 z-10 px-6 py-2.5 h-[60px] border-b border-slate-200/70 bg-white/80 backdrop-blur items-center gap-3"
    >
      <app-breadcrumb [items]="breadcrumbItems"></app-breadcrumb>

      <div class="flex-1"></div>

      <a
        routerLink="/notifications/received"
        class="w-8 h-8 rounded-lg hover:bg-slate-100 text-slate-500 flex items-center justify-center relative"
        [attr.aria-label]="'notifications' | transloco"
      >
        <igntr-icon name="bell" [size]="16"></igntr-icon>
        <span
          class="absolute top-1.5 right-1.5 w-1.5 h-1.5 rounded-full bg-[var(--primary-color)]"
        ></span>
      </a>
    </header>
  `,
})
export class DashboardHeaderComponent {
  private readonly transloco = inject(TranslocoService);

  get breadcrumbItems(): BreadcrumbItem[] {
    // return [{ label: this.transloco.translate('home') }];
    return [];
  }
}
